import { NavLink, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import classNames from 'classnames';

// style
import style from './navbar.module.css';

// data
import logo from '../../assets/logo/logo.png';
import { menu } from '../../data/menuData';
import { contactData } from '../../data/ContactData';

// components
import DesktopMenu from './components/DesktopMenu';
import MobileMenu from './components/MobileMenu';
import { Button } from '../UI/Button/Button';
import ContactModal from '../UI/Modal/ContactModal/ContactModal';

const Navbar = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handelModal = () => {
    setModalIsOpen(!modalIsOpen);
    !modalIsOpen
      ? (document.body.style.overflow = 'hidden')
      : (document.body.style.overflow = 'visible');
  };

  return (
    <>
      <nav className={style.navbar}>
        <div className="container">
          <div className={style.content}>
            {/* Logo */}
            <div className={style.logo}>
              <Link to="/">
                <img src={logo} alt="sparta" />
              </Link>

              {/* Contact */}
              <div className={style.contact}>
                <ul>
                  {contactData.map((item) => (
                    <li key={item.id}>
                      {item.icon} {item.name}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Desktop Menu & Button */}
            <div className={style.PcMenu}>
              <ul>
                {menu.map((link) => (
                  <DesktopMenu menu={link} key={link.id} />
                ))}
              </ul>
              <div className={style.btn} onClick={() => handelModal()}>
                <Button text="Записаться" type={true} />
              </div>
            </div>

            {/* Mobile Menu */}
            <div className={style.MobMenu}>
              <MobileMenu menu={menu} />
            </div>
          </div>
        </div>
      </nav>

      {/* Modal with animation */}
      <AnimatePresence>
        {modalIsOpen && (
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.3 }}
          >
            <ContactModal modalIsOpen={modalIsOpen} handelModal={handelModal} />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
